import React from "react";
import { LedgersContainer } from "../../../containers";

const Ledgers = (props) => {
  return <LedgersContainer {...props} />;
};
export default Ledgers;
